/**
 * Create modal context for custom hook
 */
import React, { createContext } from 'react'

const ModalContext = createContext({
  isOpen: false,
  title: '',
  message: '',
  html: '',
  contentComponent: <></>,
  buttons: [],
  open: () => {},
  close: () => {},
})

export default ModalContext
